import React from 'react';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import Skeleton from '@material-ui/lab/Skeleton';
import * as Mui from '@material-ui/core';

import { Container, GridList, GridListItem } from './styles';
import { formatCurrency, formatNumber } from '~/utils/format';

const PromocaoProduto = () => {
  const theme = useTheme();
  const { itemVenda, loadingProduto } = useSelector(state => state.pdv);

  return (
    <>
      <Mui.Box pt={2} flex display="flex">
        <Mui.Typography variant="caption" gutterBottom align="left">
          PROMOÇÕES
        </Mui.Typography>
      </Mui.Box>
      <Mui.Box flex display="flex" flexDirection="column">
        {loadingProduto ? (
          <>
            {[...Array(1).keys()].map(index => (
              <Container p={2} key={`index-${index}`}>
                <Mui.Box display="flex" flexDirection="column">
                  <Skeleton variant="text" height={24} width={160} />
                  <Skeleton variant="text" height={24} />
                </Mui.Box>
                <Mui.Box mb={2} mt={2}>
                  <Skeleton variant="text" height={24} />
                </Mui.Box>
                <Mui.Box display="flex" justifyContent="space-between" alignItems="center">
                  <Mui.Box align="left">
                    <Mui.Typography variant="caption" align="left">
                      Preço (R$):
                    </Mui.Typography>
                    <Skeleton variant="text" height={24} />
                  </Mui.Box>
                </Mui.Box>
              </Container>
            ))}
          </>
        ) : (
          <>
            {itemVenda?.promocoes?.map((item, index) => (
              <Container p={2} key={`index-${index}`}>
                <Mui.Box display="flex" flexDirection="column">
                  <Mui.Typography>
                    <b>{item?.descricao}</b>
                  </Mui.Typography>
                  <Mui.Typography variant="caption">
                    {item?.estProdutoGrupo
                      ? `GRUPO: ${item?.estProdutoGrupo?.descricao}`
                      : 'PRODUTO'}
                  </Mui.Typography>
                </Mui.Box>
                <Mui.Box mb={2} mt={2} display="flex" flexDirection="row" alignItems="center">
                  <Mui.Typography variant="caption" align='center'>
                    <b style={{ color: theme.palette.success }}>
                      Ativado com:
                    </b>
                    <br />
                    {item?.condicaoQuantidade} UNID
                  </Mui.Typography>
                </Mui.Box>
                <Mui.Box display="flex" justifyContent="space-between" alignItems="center">
                  <Mui.Box align="left">
                    <Mui.Typography variant="caption" align="left">
                      Preço (R$):
                    </Mui.Typography>
                    <Mui.Typography variant="h5" align="left">
                      {formatCurrency(item?.descontoValor)}
                    </Mui.Typography>
                  </Mui.Box>
                  <Chip
                    label={`${formatNumber(item?.descontoPercentual, 2) ?? 0}%`}
                    style={{ backgroundColor: '#FF0404', color: '#FFF', marginLeft: 16 }}
                  />
                </Mui.Box>
              </Container>
            ))}
          </>
        )}
      </Mui.Box>
    </>
  );
};

export default PromocaoProduto;
